<div class="ranking-list">
  <ng-container *ngIf="items.length > 0; else placeholders">
    <div class="ranking-list__item" [ngClass]="[item.schoolClassData.id === classId ? 'ranking-list__item--highlight' : '']" *ngFor="let item of items; index as idx">
      <brt-ranking-list-item [data]="item"></brt-ranking-list-item>
    </div>
  </ng-container>

  <ng-template #placeholders>
    <div class="ranking-list__item" *ngFor="let item of [].constructor(7);">
      <img class="skeleton-desktop" src="/assets/img/Rangliste-ITEM.svg" alt="">
      <img class="skeleton-mobile" src="/assets/img/Rangliste-mobile-ITEM.svg" alt="">
    </div>
  </ng-template>

</div>
